import React from 'react'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { css, cx } from '@emotion/css'
import { CsPreviousBackIcon } from '../../legacy-design-system/icons'

const getSemicircleCss = (className) => {
  return css`
    display: inline-block;
    color: ${theme.color.white};
    background-color: ${theme.color.neutral40};
    font-size: 26px;
    padding-top: 75px;
    padding-left: 3px;
    position: relative;
    top: -8px;
    left: -5px;
    height: 104px;
    width: 122px;
    border-radius: 100%;
    margin-left: 16px;
    cursor: pointer;
    &:hover {
      background-color: ${theme.color.neutral50};
      margin-left: 8px;
      .${getContainerCss(className)} {
        padding-top: 0;
      }
    }
  `
}

const getContainerCss = (className) => {
  return cx(
    className,
    css`
      position: fixed;
      top: 160px;
      right: 0px;
      height: 100px;
      width: 40px;
      overflow: hidden;
      padding-top: 4px;
    `
  )
}

export interface Props {
  readonly onClick: () => void
  readonly className?: string
}

function ArrowLeftIcon() {
  return (
    <CsPreviousBackIcon
      style={{
        top: '-37px',
        position: 'relative',
        verticalAlign: 'initial',
        pointerEvents: 'none'
      }}
    />
  )
}

export function SliderButton({ onClick, className }: Props) {
  return (
    <span className={getContainerCss(className)}>
      <span className={getSemicircleCss(className)} onClick={onClick}>
        <ArrowLeftIcon />
      </span>
    </span>
  )
}
